// extracted by mini-css-extract-plugin
export default {"timelineDetail":"TimelineDetail_timelineDetail__XnnTp","timelineDetail__image":"TimelineDetail_timelineDetail__image__xOC65"};